/**
 * Format Date as per the `en-US` pattern.
 * @param dateTime
 */
export const formatDate = (dateTime: string) => {
  return new Date(dateTime).toLocaleDateString("en-US", { dateStyle: "medium", hour12: false });
};
